import React from 'react'

function Terms() {
  return (
    <div>
    </div>
  )
}

export default Terms
